export default __webpack_public_path__ + "static/media/trending.cd2d06ac.svg";